import { render, staticRenderFns } from "./TrackCanvas.vue?vue&type=template&id=57a0637c&"
import script from "./TrackCanvas.vue?vue&type=script&lang=ts&"
export * from "./TrackCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./TrackCanvas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports